<template>
    <div class="functionWrap1">
        <div class="content">
            <div class="left">
                <div class="panelBlock">
                    <div class="panelTitle" @click="clickRoot" :class="{active:leftTab=='root'}">
                       
                       根节点下增加 
                       <i class="el-icon-success icon" v-if="leftTab=='root'"></i> 
                    </div>
                </div>
                <div class="panelBlock">
                    <div class="panelTitle" @click="leftTab='other'" :class="{active:leftTab=='other'}">
                       
                       所有功能
                       <i class="el-icon-success icon" v-if="leftTab=='other'"></i>
                    </div>
                    <div class="panelContent">
                        <el-tree :data="allFunctionList" :expand-on-click-node="false" :default-expand-all="true" :props="defaultProps"
                            @node-click="handleNodeClick" :highlight-current="true">
                            <span class="custom-tree-node" slot-scope="{ node, data }">
                                <span style="color:#ccc" v-if="data.module_state=='n'">
                                    {{data.module_name}}
                                    <span class="spanBtn" @click="openNode(data)">启用</span>
                                </span>
                                <span v-if="data.module_state=='y'">{{data.module_name}}</span>
                        
                            </span>
                        
                        </el-tree>
                    </div>
                </div>
                
            </div>
            <div class="right">
                <div class="btnGroupBox" v-if="currentChoseNode.module_state=='y'">
                    <span @click="currentTab='add'" class="tabBtn" :class="{active:currentTab=='add'}" v-if="currentChoseNode.module_name=='root'||currentChoseNode.module_parent_id==0">
                        新增功能
                        <i class="el-icon-plus"></i>
                        </span>
                    <span @click="currentTab='edit'" class="tabBtn" :class="{active:currentTab=='edit'}" v-if="currentChoseNode.module_name!='root'">
                        编辑功能
                        <i class="el-icon-edit"></i>
                        </span>
                    <span @click="currentTab='delete'" class="tabBtn" :class="{active:currentTab=='delete'}" v-if="currentChoseNode.module_name!='root'">
                        删除功能
                        <i class="el-icon-delete"></i>
                        </span>
                </div>
                <div  class="formWrap">
                    <div class="currentNodeBox">
                        当前节点名字: <span class="name">{{currentChoseNode.module_name}}</span>
                        id:{{currentChoseNode.module_id}}
                    </div>
                     <hr>
                    <el-form :model="addNodeArg" :rules="rules" ref="addNodeForm" label-width="100px" v-if="currentTab=='add'">
                        <el-form-item label="当前ID">
                            系统自动生成
                        </el-form-item>
                        <el-form-item label="父节点ID" prop="moduleParentId" required>
                            <el-input type="text" v-model="addNodeArg.moduleParentId" disabled="disabled"> </el-input>
                        </el-form-item>
                        <el-form-item label="平台id" prop="moduleSysId" required>
                            <el-input type="text" v-model="addNodeArg.moduleSysId" disabled="disabled"> </el-input>
                        </el-form-item>
                        <el-form-item label="操作人ID" prop="moduleCreateAdminId" required>
                            <el-input type="text" v-model="addNodeArg.moduleCreateAdminId" disabled="disabled"> </el-input>
                        </el-form-item>
                        <el-form-item label="功能名字" prop="moduleName" required>
                            <el-input type="text" v-model="addNodeArg.moduleName"> </el-input>
                        </el-form-item>
                        <el-form-item label="key" prop="moduleKey" required>
                            <el-input type="text" v-model="addNodeArg.moduleKey"> </el-input>
                        </el-form-item>
                        <el-form-item label="功能顺序" required prop="moduleSequence" >
                            <el-input type="text" v-model.number="addNodeArg.moduleSequence"> </el-input>
                        </el-form-item>
                        <el-form-item>
                            <el-button @click="addNode('addNodeForm')" type="success">增加功能</el-button>
                        </el-form-item>
                    </el-form>
                    <el-form :model="editNodeArg" :rules="rules" ref="editNodeForm" label-width="100px" v-if="currentTab=='edit'">
                        <el-form-item label="当前ID">
                            <el-input type="text" v-model="editNodeArg.moduleId" disabled="disabled"> </el-input>
                        </el-form-item>
                        <el-form-item label="父节点ID" prop="moduleParentId" required>
                            <el-input type="text" v-model="editNodeArg.moduleParentId" disabled="disabled"> </el-input>
                        </el-form-item>
                        <el-form-item label="平台id" prop="moduleSysId" required>
                            <el-input type="text" v-model="editNodeArg.moduleSysId" disabled="disabled"> </el-input>
                        </el-form-item>
                        <el-form-item label="操作人ID" prop="adminId" required>
                            <el-input type="text" v-model="editNodeArg.adminId" disabled="disabled"> </el-input>
                        </el-form-item>
                        <el-form-item label="功能名字" prop="moduleName" required>
                            <el-input type="text" v-model="editNodeArg.moduleName"> </el-input>
                        </el-form-item>
                        <el-form-item label="key" prop="moduleKey" required>
                            <el-input type="text" v-model="editNodeArg.moduleKey"> </el-input>
                        </el-form-item>
                        <el-form-item label="功能顺序"  prop="moduleSequence" required>
                            <el-input type="text" v-model.number="editNodeArg.moduleSequence"> </el-input>
                        </el-form-item>
                        <el-form-item>
                            <el-button @click="editNode('editNodeForm')" type="primary">编辑功能</el-button>
                        </el-form-item>
                    </el-form>
                    <el-form :model="deleteNodeArg" :rules="rules" ref="deleteNodeForm" label-width="100px" v-if="currentTab=='delete'">
                        <el-form-item label="平台id">
                            <span>{{deleteNodeArg.moduleSysId}}</span>
                        </el-form-item>
                        <el-form-item label="操作人ID" >
                            <span>{{deleteNodeArg.adminId}}</span>
                        </el-form-item>
                        <el-form-item label="当前ID" prop="moduleId" required>
                            <el-input type="text" v-model="deleteNodeArg.moduleId" disabled="disabled"> </el-input>
                        </el-form-item>
                        <el-form-item label="功能名字" prop="moduleName" required>
                            <el-input type="text" v-model="deleteNodeArg.moduleName" disabled="disabled"> </el-input>
                        </el-form-item>
                        <div></div>
                        <el-form-item>
                            <div style="padding-left:100px">
                                <el-button @click="deleteNode('deleteNodeForm')" type="danger">删除功能</el-button>
                            </div>
                            
                        </el-form-item>
                    </el-form>
                </div>
                
            </div>
        </div>

    </div>
</template>

<script>
    import {
        json,
        wordData,
        utils
    } from '@/common/common.js'
    import {
        ajaxLogin,
        api
    } from '@/common/request.js'
    export default {
        name: 'adminIndex',
        data() {
            return {
                leftTab:'',
                currentTab: '',
                addNodeArg: {},
                editNodeArg: {},
                deleteNodeArg: {},
                rules: {},
                currentChoseNode: {},
                defaultProps: {
                    children: 'subModule',
                    label: 'module_name'
                },
                allFunctionList: []
            }
        },
        computed: {
            adminId() {
                return utils.getAdminId()
            },
            roleId() {
                return utils.getRoleId()
            },
        },
        methods: {
            getAllFunction() {
                let _this = this
                let arg = {
                    moduleSysId: utils.getSysId()
                    // moduleSysId:2//ces
                }
                ajaxLogin('/admin/system/allModuleList', arg).then(function(res) {
                    if (res.errorCode == 200) {
                        _this.allFunctionList = res.data
                    } else {}

                }, function(res) {})
            },
            refreshPage() {
                this.getAllFunction()
                this.currentChoseNode={}
                this.addNodeArg={}
                this.editNodeArg={}
                this.deleteNodeArg={}
            },
            handleNodeClick(data) {
                let _this = this
                console.log(data)
                this.currentChoseNode = data
                this.currentTab='edit'
                this.addNodeArg = {
                    "moduleSysId": utils.getSysId(),
                    "moduleName": "",
                    moduleKey:"",
                    "moduleCreateAdminId": _this.adminId,
                    "moduleParentId": data.module_id,
                    "moduleSequence": ""
                }
                this.editNodeArg = {
                    "moduleName": data.module_name,
                    "moduleParentId": data.module_parent_id,
                    "adminId": _this.adminId,
                     moduleKey:data.module_key,
                    "moduleSequence": data.module_sequence,
                    "moduleId": data.module_id,
                    "moduleSysId": utils.getSysId(),
                }
                this.deleteNodeArg={
                    "moduleSysId":utils.getSysId(),
                    "moduleState":"n",
                    "moduleId": data.module_id,
                    "adminId":_this.adminId,
                    "moduleName": data.module_name,
                }
            },
            clickRoot() {
                let _this = this
                this.leftTab='root'
                this.currentTab='add'
                this.currentChoseNode = {
                    module_name:"root",
                    module_id:0,
                    module_state:'y',
                }
                this.addNodeArg = {
                    "moduleSysId": utils.getSysId(),
                    "moduleName": "",
                    "moduleKey":'',
                    "moduleCreateAdminId": _this.adminId,
                    "moduleParentId": 0,
                    "moduleSequence": ""
                }
            },
            addNode(formName) {
                let _this = this
                console.log(_this.addNodeArg)
                this.$refs[formName].validate((valid) => {
                    if (valid) {
                        if (!confirm("确认新增功能 吗？")) {
                            return false
                        }
                        ajaxLogin('/admin/system/addSystemModule', _this.addNodeArg).then(function(res) {
                            if (res.errorCode == 200) {
                                _this.$message({
                                    message: "新增成功",
                                    type: 'success',
                                    duration: 1000
                                });
                                _this.refreshPage()
                            } else {
                                _this.$message({
                                    message: res.errorMsg,
                                    type: 'error',
                                });
                            }

                        }, function(res) {})
                    }
                })
            },
            editNode(formName) {
                let _this = this
                console.log(_this.editNodeArg)
                this.$refs[formName].validate((valid) => {
                    if (valid) {
                        if (!confirm("确认编辑该功能吗？")) {
                            return false
                        }
                        ajaxLogin('/admin/system/editModule', _this.editNodeArg).then(function(res) {
                            if (res.errorCode == 200) {
                                _this.$message({
                                    message: "编辑成功",
                                    type: 'success',
                                    duration: 1000
                                });
                                _this.refreshPage()
                            } else {
                                _this.$message({
                                    message: res.errorMsg,
                                    type: 'error',
                                });
                            }
            
                        }, function(res) {})
                    }
                })
            },
            deleteNode(formName) {
                let _this = this
                console.log(_this.deleteNodeArg)
                this.$refs[formName].validate((valid) => {
                    if (valid) {
                        if (!confirm("确认删除该功能吗？")) {
                            return false
                        }
                        ajaxLogin('/admin/system/updateModuleStatus', _this.deleteNodeArg).then(function(res) {
                            if (res.errorCode == 200) {
                                _this.$message({
                                    message: "删除成功",
                                    type: 'success',
                                    duration: 1000
                                });
                                _this.refreshPage()
                            } else {
                                _this.$message({
                                    message: res.errorMsg,
                                    type: 'error',
                                });
                            }
            
                        }, function(res) {})
                    }
                })
            },
            openNode(data){
                let _this=this
                let arg={
                    "moduleSysId":utils.getSysId(),
                    "moduleState":"y",
                    "moduleId":data.module_id,
                    "adminId":_this.adminId,
                } 
                if (!confirm("确认启用该功能吗？")) {
                   return false
                }
               ajaxLogin('/admin/system/updateModuleStatus',arg).then(function(res) {
                   if (res.errorCode == 200) {
                       _this.$message({
                           message: "启用成功",
                           type: 'success',
                           duration: 1000
                       });
                       _this.refreshPage()
                   } else {
                       _this.$message({
                           message: res.errorMsg,
                           type: 'error',
                       });
                   }
                           
               }, function(res) {})
            },
        },
        mounted() {
            this.getAllFunction()
            //初始化
            this.clickRoot() 
            this.leftTab='other'
        }
    }
</script>

<style scoped lang="scss">
    // *{outline:1px solid red}
    .functionWrap1 {
        padding: 5px;
       hr{border:1px dotted #ddd;margin:10px 0;}

        .content {
            display: flex;
            min-height: 500px;
            .left {
                width: 270px;
                background: #fff;
                margin-right: 10px;
                padding: 10px;

                .panelBlock{
                    margin-bottom: 10px;
                    .panelTitle{
                        background: #eee;color:#000;padding:15px;cursor: pointer; margin-bottom: 10px; position: relative;font-size:16px;padding-left:20px;
                        .icon{position: absolute;right:10px;top:20px;}
                    }
                    .panelTitle:hover{
                        background: skyblue; 
                    }
                    .panelTitle.active{
                        background: #3b4a63; color:#fff;
                    }
                    .panelContent{
                        
                    }
                }
            }

            .right {
                background: #fff;
                padding:10px;
                flex: 1;

                .formWrap {
                    border: 1px solid #3c9fdb;
                    padding:10px;
                }

                .currentNodeBox {
                    padding:0 30px;
                    .name {
                        font-size: 15px;
                        color: blue; margin:0 20px;
                    }
                }

                .btnGroupBox {
                    display: flex;

                    .tabBtn {
                        padding: 12px 50px;
                        margin-right: 12px;
                        border: 1px solid #fff;
                        border-bottom: 0;
                    }

                    .tabBtn.active {
                        background: #3c9fdb;
                        color: #fff;
                        cursor: pointer;
                        border: 1px solid #3c9fdb;
                        border-bottom: 0;
                    }

                    .tabBtn:hover {
                        cursor: pointer;
                        border: 1px solid #eee;
                        border-bottom: 0;
                    }
                }
            }
        }
    }
</style>



// WEBPACK FOOTER //
// src/pages/system/functionManager.vue